export default __webpack_public_path__ + "static/media/references__it.8dc5aa5c.jpg";